export const CREATE_NOTE_AUTOMATION = 'CREATE_NOTE_AUTOMATION'
export const UPDATE_NOTE_AUTOMATION = 'UPDATE_NOTE_AUTOMATION'
export const DELETE_NOTE_AUTOMATION = 'DELETE_NOTE_AUTOMATION'
